import * as React from 'react';
import { currentLanguage, translate, useDynamicData } from '@avensia/excite';
import { styled } from '@glitz/react';
import { ButtonLink } from 'webapp/components/button';
import { Theme } from 'webapp/theme';
import { UserIcon } from 'webapp/components/icons';
import { useLanguageOptions } from 'webapp/shell/header/CountrySelector';
import { FieldSize } from 'webapp/components/field-size';
import NativeSelect from 'webapp/components/form/native-select';
import { authenticateIfNeeded } from '@avensia/excite-commercetools/authentication';
import { NnTestIdProps } from 'webapp/shared/test-ids';

type PropType = {
  close: () => void;
};

export const MobileMenuBottomBar = (props: PropType) => {
  const { onSelectLanguage, options } = useLanguageOptions();
  const isLoggedIn = useDynamicData<NordicNest.Api.CustomerApiModel>()[0]?.isLoggedIn;
  const myPagesStartPageUrl = useDynamicData<NordicNest.Api.WellknownPagesApiModel>()[0]?.myPagesStartPageUrl;

  return (
    <BottomBar>
      <LoginButton
        disableRippleEffect
        size={FieldSize.XSmall}
        as={Theme.Transparent}
        onClick={() => {
          authenticateIfNeeded();
          props.close();
        }}
        to={(isLoggedIn && myPagesStartPageUrl) || ''}
        {...NnTestIdProps.MobileMenuMyPagesButton}
      >
        <UserIcon />
        <LoginText>{isLoggedIn ? translate(t => t.header.myPages) : translate(t => t.login.loginAction)}</LoginText>
      </LoginButton>
      <LanguageSelect
        onChange={e => onSelectLanguage(e.currentTarget.value)}
        value={currentLanguage()}
        options={options}
      />
    </BottomBar>
  );
};

const LanguageSelect = styled(NativeSelect, {
  fontSize: t => t.fontSize.xxs,
});

const BottomBar = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: t => t.mobileMenu?.accentColor,
  padding: { x: t => t.spacing.m, y: t => t.spacing.s },
});

const LoginButton = styled(ButtonLink, {
  padding: { y: t => t.spacing.xs, left: 0 },
  gap: t => t.spacing.xs,
  textTransform: 'none',
});

const LoginText = styled.span({
  fontSize: t => t.mobileMenu?.fontSize,
});
